import { render, staticRenderFns } from "./BillingDetails.vue?vue&type=template&id=2a8592bb&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8592bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8592bb')) {
      api.createRecord('2a8592bb', component.options)
    } else {
      api.reload('2a8592bb', component.options)
    }
    module.hot.accept("./BillingDetails.vue?vue&type=template&id=2a8592bb&scoped=true", function () {
      api.rerender('2a8592bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialManagement/dailySettlementStatement/components/BillingDetails.vue"
export default component.exports